import request from '@/utils/request'
import { ADMIN_URL } from '@/utils/constant'

export function getAnnounceList(currPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getannouncelist`,
    method: 'post',
    params: {
      page: currPage,
      limit: pageSize,
      ...params
    }
  })
}

export function searchPushUserList(currPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/searchpushuserlist`,
    method: 'get',
    params: {
      page: currPage,
      pageSize,
      ...params
    }
  })
}

export function getAnnounceInfo(params) {
  return request({
    url: `${ADMIN_URL}/getannounceinfo`,
    method: 'get',
    params
  })
}

export function addOrUpdateAnnounce(data) {
  const action = data.id ? 'updateannounce' : 'addannounce'
  return request({
    url: `${ADMIN_URL}/${action}`,
    method: 'post',
    data
  })
}

export function delAnnounce(data) {
  return request({
    url: `${ADMIN_URL}/delannounce`,
    method: 'post',
    params: data
  })
}
export function doPushAnnounce(data) {
  return request({
    url: `${ADMIN_URL}/dopush`,
    method: 'post',
    data
  })
}

export function getPushedList(currPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getpushedlist`,
    method: 'get',
    params: {
      page: currPage,
      limit: pageSize,
      ...params
    }
  })
}

